import { type FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { FormHelperText } from 'base-ui'

import { type DirectContactFormValues } from '../DirectContactFormModel'

import { DirectContactFormOrderProductsSelectionContainer } from './DirectContactFormOrderProductsSelectionContainer'

export const DirectContactFormOrderSelectionField: FC<{
  onClick: () => void
}> = ({ onClick }) => {
  const intl = useIntl()
  const { control } = useFormContext<DirectContactFormValues>()
  const requiredMessage = intl.formatMessage({ id: 'form.error.input.missing' })

  return (
    <Controller
      control={control}
      name="orderId"
      render={({ field, fieldState }) => (
        <div className="min-w-0">
          <DirectContactFormOrderProductsSelectionContainer
            data-qa-id="contact-form-orderId"
            hasError={Boolean(fieldState.error)}
            label={`${intl.formatMessage({
              id: 'direct.contact.form.order.number',
            })}*`}
            onClick={onClick}
            selectedValue={field.value}
          />
          {fieldState.error?.message ? (
            <FormHelperText
              className="px-6 text-dark-error"
              data-qa-id="contact-form-orderId-error"
              id="contact-form-orderId-error"
            >
              {fieldState.error.message}
            </FormHelperText>
          ) : null}
        </div>
      )}
      rules={{ required: requiredMessage }}
    />
  )
}
